import React, { Fragment } from "react";
export const SkeletonCheckbox = (props) => (React.createElement(Fragment, null,
    React.createElement("label", { htmlFor: "loadingCheckbox", className: props?.className },
        React.createElement("input", { name: "loading", id: "loadingCheckbox", disabled: true, type: "checkbox" }),
        React.createElement("span", { className: "sr-only" }, "Select all rows"))));
